export default function FluidHeader() {
  const header = document.querySelector('.o-header')
  const hero =
    document.querySelector('section.o-hero') ||
    document.querySelector('section.o-hero-left-text') ||
    document.querySelector('section.o-hero-center-text')

  const expertiseSection = document.querySelector('.o-expertise-list')
  const scrollContainer = document.querySelector('.scroll-container')
  const elementLinks = document.querySelector('.element-links')

  const mainElement = document.querySelector('main')
  const secondSection = mainElement
    ? mainElement.querySelectorAll('section')[1]
    : null

  if (!header || !hero) return

  if (!document.querySelector('section.o-hero')) {
    header.classList.add('blur')
  }

  const enableNewLogic = expertiseSection && scrollContainer && elementLinks

  const checkScroll = () => {
    const scrollTop = window.scrollY || document.documentElement.scrollTop
    const windowHeight = window.innerHeight

    let visibility = 1 - scrollTop / windowHeight
    visibility = Math.max(0, Math.min(1, visibility))

    hero.style.setProperty('--hero-opacity', visibility.toFixed(2))
    header.style.setProperty('--header-opacity', visibility.toFixed(2))

    let shouldHaveBackground = scrollTop > windowHeight

    if (secondSection) {
      const secondSectionRect = secondSection.getBoundingClientRect()

      if (secondSectionRect.top <= 1) {
        shouldHaveBackground = true
      } else {
        shouldHaveBackground = false
      }
    }

    if (enableNewLogic) {
      const expertiseRect = expertiseSection.getBoundingClientRect()
      const scrollRect = scrollContainer.getBoundingClientRect()
      const elementLinksRect = elementLinks.getBoundingClientRect()

      const isInsideExpertise =
        expertiseRect.top <= 0 && expertiseRect.bottom > 0

      if (isInsideExpertise) {
        const shouldActivate = scrollRect.top <= 1
        const shouldDeactivate = elementLinksRect.bottom > 0

        if (shouldActivate && !scrollContainer.classList.contains('active')) {
          scrollContainer.classList.add('active')
          shouldHaveBackground = false
        }

        if (scrollContainer.classList.contains('active') && shouldDeactivate) {
          scrollContainer.classList.remove('active')
        }

        if (scrollContainer.classList.contains('active')) {
          shouldHaveBackground = false
        }
      } else {
        scrollContainer.classList.remove('active')
      }
    }

    if (shouldHaveBackground) {
      header.style.opacity = 1
      header.classList.add('background')
    } else {
      header.style.opacity = ''
      header.classList.remove('background')
    }
  }

  window.addEventListener('scroll', checkScroll)
  checkScroll()
}
